import { useLazyQuery } from "@apollo/client";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Accordion, AccordionDetails, AccordionSummary } from "../common/Accordion";
import Loading from "../common/Loading";
import { captureException } from "../sentry";
import { generateDescription, GenerateDescriptionQueryType, GenerateDescriptionQueryVariables } from "./EnvironmentDescription.gql";

interface Props {
    photo: Blob;
    notVisible?: boolean;
}

const EnvironmentDescription: React.FunctionComponent<Props> = ({ photo, notVisible }) => {
    const [fetch, { data, loading, error }] = useLazyQuery<GenerateDescriptionQueryType, GenerateDescriptionQueryVariables>(generateDescription, {
        variables: { photo },
        onError: (error) => {
            captureException(error);
        },
        fetchPolicy: "network-only",
    });
    const { t } = useTranslation();

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        console.log("Description");
        fetch();
    }, [fetch]);

    const computedError = error?.message ?? data?.generateDescription?.error;

    return (
        <>
            {!notVisible && (
                <Accordion expanded={expanded} onChange={handleChange} style={{ marginTop: 20, width: "100%" }}>
                    <AccordionSummary>
                        <Typography>{expanded ? t("hide_description") : t("show_description")}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {loading && <Loading />}
                        {computedError && <Typography>{computedError}</Typography>}
                        {data && data.generateDescription.description && <Typography>{data.generateDescription.description}</Typography>}
                    </AccordionDetails>
                </Accordion>
            )}
        </>
    );
};

export default EnvironmentDescription;
